export enum InputType {
    TEXT = 1,
    INTEGER = 2,
    DECIMAL = 3
}
